<template>
  <span :class="presenter.textClass">{{ presenter.label }}</span>
</template>

<script>
export default {
  computed: {
    presenter () {
      const days = Math.floor(this.timestat)
      const presenter = {
        label: days,
        days: days,
        textClass: null
      }
      if (days === 0) {
        presenter.label = 'Same Day'
        presenter.textClass = 'has-text-success'
      } else if (days <= 2) {
        presenter.textClass = 'has-text-success'
      } else if (days >= 5) {
        presenter.textClass = 'has-text-warning'
      }
      return presenter
    }
  },
  props: ['timestat']
}
</script>
